<template>
    <div>
        <template v-if="comments.length > 0">
            <div v-for="(comment, i) in comments" :key="comment.id">
                <b-card class="mb-2 comment-item">
                    <div class="media">
                        <div class="media-body ml-4">
                            <div class="float-right" v-if="comment.user_id == user.id">
                                <button class="btn btn-sm btn-default" v-on:click="editComment(comment)" title="Edit Comment">
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-sm btn-default" v-on:click="showDeleteComment(comment)" title="Delete Comment">
                                    <span class="text-danger"><i class="fas fa-trash"></i></span>
                                </button>
                            </div>
                            <a href="javascript:void(0)">{{ comment.first_name }} {{ comment.last_name }}</a>
                            <div class="mb-2">
                                <span class="text-muted">{{ comment.created_at | moment('timezone', timezone, "MM/DD/YYYY hh:mm a") }}</span>
                            </div>
                            <div class="mb-2">{{ comment.comment_details }}</div>

                            <a href="javascript:void(0)" v-if="!comment.readby" v-on:click="loadReadBy(i, comment.id)">View Read By</a>
                            <div class="text-muted" v-else>
                                Read By ({{ comment.readby.length }}):
                                <span v-for="(user, j) in comment.readby">
                                    <span v-if="j > 0">, </span>
                                    <span :title="'Read At: '+user.read_at_formatted">{{ user.first_name }} {{ user.last_name }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </b-card>
            </div>
        </template>
        <template v-else>
            <b-card>
                <div class="card-body">
                    -- No Comments --
                </div>
            </b-card>
        </template>

        <b-modal v-model="show_delete_comment" :ref="'commentDeleteModal'" title="Delete Comment" size="md" no-fade ok-variant="danger" ok-title="Delete Comment" @ok="deleteComment()">
            <div class="alert alert-danger mb-3">
                <strong>Waring:</strong> You are about to delete the following comment. This is a permanent action and cannot be undone. Are you sure you want to proceed?
            </div>

            <div>{{ delete_comment.comment_details }}</div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {

            assetComments: {
                type: Array,
                default: null,
            },

            ajaxLoad: {
                type: Boolean,
                default: false,
            },

            assetType: {
                type: String,
                default: null,
            },

            assetId: {
                type: Number,
                default: null,
            }
        },

        data() {
            return {
                loading: false,
                show_delete_comment: false,
                timezone: this.$root.timezone,
                user: this.$store.state.user,
                comments: [],
                delete_comment: {},
            }
        },

        methods: {
            getComments(){
                //Loading
                this.loading = true;

                //Make sure asset resources are defined
                if(!this.assetType || !this.assetId)
                {
                    //Alert the user
                    this.$toastr.w('Asset Type and ID are required to load comments');

                    //Stop here
                    return;
                }

                //Send it
                this.$http.get('/comments/' + this.assetType + '/' + this.assetId)
                    .then(response => {
                        //Set the part
                        this.comments = response.data;

                        //Emit
                        this.$emit('commentCount', response.data.length);
                    })
                    .catch(error => {
                        //Alert the user
                        this.$toastr.e(error, 'Something Went Wrong');
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            editComment(comment){
                //Emit
                this.$emit('editComment', comment);
            },

            addComment(comment){
                //Push it
                this.comments.unshift(comment);
            },

            updateComment(comment){
                //Loop and splic
                for(var i = 0; i < this.comments.length; i++)
                {
                    //Check ID
                    if(this.comments[i].id == comment.id)
                    {
                        this.comment.splice(i, 1, comment);
                    }
                }
            },

            showDeleteComment(comment){
                //SEt the comment
                this.delete_comment = comment;

                //Show it
                this.show_delete_comment = true;
            },

            deleteComment(){
                //Show the modal?

                //Send it
                this.$http.delete('/comments/'+this.delete_comment.id)
                    .then(response => {
                        //Set the data
                        //this.comments[i].readby = response.data.users;
                        for (var i = 0; i < this.comments.length; i++)
                        {
                            //Check id
                            if(this.comments[i].id == this.delete_comment.id)
                            {
                                //Remove it
                                this.comments.splice(i, 1);
                            }
                        }

                        //Reset
                        this.delete_comment = {};

                        //Hide it
                        this.show_delete_comment = false;

                        //Re-render
                        this.$forceUpdate();

                        //Alert
                        this.$toastr.s('Comment Deleted');
                    })
                    .catch(error => {

                    })
                    .then(() => {

                    });
            },

            loadReadBy(i, comment_id){
                //Loading

                //Get the read by
                this.$http.get('/comments/read-by/'+comment_id)
                    .then(response => {
                        //Set the data
                        this.comments[i].readby = response.data.users;

                        //Re-render
                        this.$forceUpdate();
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading_comments = false;
                    });
            },
        },

        mounted() {
            //Check for ajax load
            if(this.ajaxLoad)
            {
                this.getComments();
            }

            //Check it
            if(this.assetComments)
            {
                this.comments = this.assetComments;
            }
        }
    }
</script>

<style type="text/css" scope>
    .comment-item .card-body {
        padding: 1rem 0.5rem;
    }
</style>
